<template>
  <Modal
    ref="createAnnotationReviewModal"
    :title="'Add New Task'"
    :width="'600px'"
  >
    <template #modal-main>
      <div class="settings container scrollbar">
        <!-- <div class="row mb-3">
          <div class="col-12 settings__control-group">
            <label class="required">Type</label>
            <select
              id="type-select"
              v-model="type"
              class="select"
            >
              <option disabled :value="''">Select a Type</option>
              <option v-for="(option, i) in types" :key="`taskboard-type-${i}`" :value="option.type">
                {{ option.name }}
              </option>
            </select>
          </div>
        </div> -->
        <div class="row mb-3">
          <div class="col-12 settings__control-group">
            <div class="input-label d-flex">
              <label class="label required">Task Name</label>
            </div>
            <input
              v-model="reviewTaskInputName"
              class="input"
              type="text"
              placeholder="Name"
            >
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12 settings__control-group">
            <div class="input-label d-flex">
              <label class="label">Task Description</label>
            </div>
            <textarea
              v-model="reviewTaskInputDescription"
              rows="2"
              cols="50"
              placeholder="Description"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12 settings__control-group">
            <div class="input-label d-flex">
              <label class="label required">Dataset</label>
              <SVGIcon
                v-tooltip="'Select the dataset you wish to perform auditing or labelling on.'"
                :width="'20px'"
                :height="'20px'"
                :iconName="'info'"
                class="tooltip-icon"
              />
            </div>
            <select v-model="srcDataset" class="select" required>
              <option :key="'review-select-null'" disabled :value="null">Select a Dataset</option>
              <option v-for="d in datasets" :key="`review-select-${d.id}`" :value="d">
                {{ d.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12 settings__control-group">
            <div class="input-label d-flex">
              <label class="label required">Task type</label>
              <SVGIcon
                v-tooltip="`Label tasks allow users to create or edit annotations on the same annotation set.
                Audit tasks allow users to create, approve, or make changes to annotations and save result in a different annotation set.`"
                :width="'20px'"
                :height="'20px'"
                :iconName="'info'"
                class="tooltip-icon"
              />
            </div>
            <div class="value permission-list">
              <div class="row mt-1 d-flex align-items-center">
                <input
                  id="percent-split-radio"
                  v-model="taskType"
                  type="radio"
                  name="percent_group_split"
                  value="label"
                  class="split-radio"
                >
                <div class="col settings__control-group">
                  <div class="input-label d-flex">
                    <label class="label">Label</label>
                  </div>
                  <div class="input-label">
                    <span class="subtitle">Create or edit annotations.</span>
                  </div>
                </div>
              </div>
              <div class="row mt-3 d-flex align-items-center">
                <input
                  id="percent-split-radio"
                  v-model="taskType"
                  type="radio"
                  name="percent_group_split"
                  value="audit"
                  class="split-radio"
                >
                <div class="col settings__control-group">
                  <div class="input-label d-flex">
                    <label class="label">Audit</label>
                  </div>
                  <div class="input-label">
                    <span class="subtitle">Create, edit, or approve from reference annotations.</span>
                  </div>
                </div>
              </div>
              <!-- <input
                    id="percent-split-radio"
                    v-model="groupSplit"
                    type="radio"
                    name="percent_group_split"
                    value="percent"
                    class="split-radio"
                  >

                  <div class="label-text">Labelling</div>

                  <span class="chkbx-li__subtitle">Create or edit annotations.</span> -->
            </div>
          </div>
        </div>

        <div v-if="srcDataset && taskType === 'audit'" class="row mb-3">
          <div class="col-12 settings__control-group">
            <div class="input-label d-flex">
              <label class="label required">Reference Annotation Set</label>
              <SVGIcon
                v-tooltip="'Select the annotation set to use as the reference for auditing. Results of auditing will be saved to target annotation set.'"
                :width="'20px'"
                :height="'20px'"
                :iconName="'info'"
                class="tooltip-icon"
              />
            </div>
            <select v-model="srcAnnotationSet" class="select" required>
              <option :key="'review-select-null'" disabled :value="null">Select a Rereference Annotation Set</option>
              <option v-for="a in annotationSets" :key="`review-select-${a.id}`" :value="a">
                {{ a.name }}
              </option>
            </select>
          </div>
        </div>

        <div v-if="srcDataset" class="row mb-3">
          <div class="col-12 settings__control-group">
            <div class="input-label d-flex">
              <label class="label">Target Annotation Set</label>
              <SVGIcon
                v-tooltip="'Select the annotation set where your annotations will be saved. You can input a new name, in  which case a new annotation set will be created and used as target.'"
                :width="'20px'"
                :height="'20px'"
                :iconName="'info'"
                class="tooltip-icon"
              />
            </div>
            <select v-model="destAnnotationSet" class="select" required>
              <option :key="'review-select-null'" :value="null">New annotation set ({{ taskType === 'audit' ? 'audited ' : '' }}annotations)</option>
              <option v-for="a in destAnnotationSets" :key="`review-select-${a.id}`" :value="a">
                {{ a.name }}
              </option>
            </select>
          </div>
        </div>

        <!-- <div class="row mt-3">
          <div class="col-12 settings__control-group">
            <label class="label required">Access Sharing</label>
            <div class="value permission-list">
              <div class="role-grid-single-row">
                <div class="chkbx-li">
                  <v-checkbox
                    v-model="presetRole"
                    :hide-details="true"
                    density="compact"
                    value="default"
                    :false-icon="'mdi-checkbox-blank-circle-outline'"
                    :true-icon="'mdi-circle-slice-8'"
                  >
                    <template #label>
                      <div class="label-text">Share with organization</div>
                    </template>
                  </v-checkbox>
                  <span class="chkbx-li__subtitle">Everyone in your organization has access to this task.</span>
                </div>
                <div class="chkbx-li">
                  <v-checkbox
                    v-model="presetRole"
                    :hide-details="true"
                    density="compact"
                    value="user"
                    :false-icon="'mdi-checkbox-blank-circle-outline'"
                    :true-icon="'mdi-circle-slice-8'"
                  >
                    <template #label>
                      <div class="label-text">Share with users</div>
                    </template>
                  </v-checkbox>
                  <span class="chkbx-li__subtitle">Only owner and selected users have access to this task.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <template v-if="presetRole === 'user'">
          <div class="row">
            <v-combobox
              v-model="userInputValue"
              class="combobox"
              chips
              clearable
              multiple
              :color="'#250e81'"
              :density="'comfortable'"
              :hide-details="true"
              :label="'Add People'"
              :items="userList.filter(obj => obj['username'] !== user.username)"
              :item-title="(obj) => obj['first_name'] && obj['last_name'] ? `${obj['first_name']} ${obj['last_name']}` : obj['username']"
              :item-value="(obj) => obj['username']"
              :return-object="false"
              variant="outlined"
            />
          </div>
        </template> -->
        <div v-if="message" class="row mt-3">
          <div class="col-12 settings__control-group">
            <div class="result error">
              <span>{{ message }}</span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <div class="footer">
        <button
          class="button modal-action-button"
          @click="createReviewTask"
        >
          Create Task
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import Modal from '@/components/Modal.vue';
import SVGIcon from '@/components/SVGIcon.vue';
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

const $toast = useToast();

export default {
  name: 'CreateAnnotationReviewTaskModal',
  components: {
    Modal,
    SVGIcon,
  },
  props: {
    datasets: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['review-task-created', 'review-task-created-error'],
  data() {
    return {
      message: '',
      reviewTaskInputName: null,
      reviewTaskInputDescription: null,
      taskType: "label",
      types: [
        {
          name: 'Label',
          type: 'label',
        },
        {
          name: 'Audit',
          type: 'audit',
        },
      ],
      presetRole: 'default',
      userList: [],
      userInputValue: [],
      srcDataset: null,
      srcAnnotationSet: null,
      destAnnotationSet: null,
    };
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    annotationSets() {
      if (this.srcDataset && this.srcDataset.annotation_sets) {
        return this.srcDataset.annotation_sets;
      } else {
        return [];
      }
    },
    destAnnotationSets() {
      if (this.srcAnnotationSet && this.annotationSets.length > 0 && this.taskType === 'audit') { // audit task will fitler out the same set as source
        return this.annotationSets.filter((set) => set.id !== this.srcAnnotationSet.id);
      } else if (this.srcAnnotationSet && this.annotationSets.length > 0 && this.taskType === 'label') {
        return this.annotationSets;
      } else {
        return [];
      }
    },
  },
  watch: {
    srcDataset: {
      deep: true,
      handler() {
        if (this.srcDataset) {
          if (this.srcDataset.annotation_sets && this.srcDataset.annotation_sets.length > 0) {
            this.srcAnnotationSet = this.srcDataset.annotation_sets[0];
          }
          this.destAnnotationSet = null;
        }
      },
    },
  },
  async mounted() {
    this.$refs.createAnnotationReviewModal.showModal();
    this.dataConnect = new DatastoreConnect(this.$store.state.enterpriseServerUrl);
    this.getUsersListByOrganization(this.user.organization_id);
    if (this.datasets) {
      this.srcDataset = this.datasets[0];
      if (this.srcDataset.annotation_sets && this.srcDataset.annotation_sets.length > 0) {
        this.srcAnnotationSet = this.srcDataset.annotation_sets[0];
      }
    }
  },
  methods: {
    showModal() {
      this.$refs.createAnnotationReviewModal.showModal();
    },
    async getUsersListByOrganization(id) {
      await this.dataConnect.getUserListByOrganization({
        organization_id: id,
      })
        .then((data) => {
          if (data.result) {
            this.userList = data.result;
            this.userInputValue = [];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async createReviewTask() {
      if (!this.reviewTaskInputName) {
        $toast.open({
          queue: true,
          duration: 5000,
          message: `Error: Missing name`,
          type: "error",
          position: "top",
        });
        return;
      }
      if (!this.srcDataset) {
        $toast.open({
          queue: true,
          duration: 5000,
          message: `Error: Missing dataset`,
          type: "error",
          position: "top",
        });
        return;
      }

      let reviewTaskDestinationAnnotationSet = null;
      if (!this.destAnnotationSet) {
        const annName = `${this.taskType === 'audit' ? 'audited ' : ''}annotations`;
        reviewTaskDestinationAnnotationSet = await this.createAnnotationSet(annName);
      } else {
        reviewTaskDestinationAnnotationSet = this.destAnnotationSet;
      }

      let inputName = '';
      if (this.reviewTaskInputName === '') {
        inputName = `${reviewTaskDestinationAnnotationSet.name.replace(/ /g, "-")}`;
      } else {
        inputName = this.reviewTaskInputName;
      }

      const params = {
        type: 'audit',
        source_annotation_set_id: null,
        dest_annotation_set_id: reviewTaskDestinationAnnotationSet.id,
        dataset_id: this.srcDataset.id,
        name: inputName,
        users: this.users,
        description: this.reviewTaskInputDescription,
      };

      if (this.presetRole === 'user') {
        params.usernames = [...this.userInputValue];
        params.usernames.push(this.user.username);
      }

      if (this.taskType === 'audit' && Object.keys(this.srcAnnotationSet).length > 0) {
        params['source_annotation_set_id'] = this.srcAnnotationSet.id;
      } else if (this.taskType === 'label' && Object.keys(this.srcAnnotationSet).length > 0) {
        params['source_annotation_set_id'] = reviewTaskDestinationAnnotationSet.id;
      }

      const resp = await this.dataConnect.addReviewTask(params)
        .catch((error) => {
          // TODO: handle error
          $toast.open({
            queue: true,
            duration: 5000,
            message: `Error adding task: ${error.message}`,
            type: "error",
            position: "top",
          });
        });
      if (resp.error || !resp.result) {
        $toast.open({
          queue: true,
          duration: 5000,
          message: `Error adding task: ${resp.error.message}`,
          type: "error",
          position: "top",
        });
        await this.refreshAnnotationSets();
      } else {
        this.$emit('review-task-created');
        await this.refreshAnnotationSets();
        this.$refs.createAnnotationReviewModal.closeModal();
      }
    },
    async createAnnotationSet(annotationSetName) {
      const resp = await this.dataConnect.createAnnotationSet({
        name: annotationSetName,
        description: `Review Task for the annotation set "${annotationSetName}"`,
        operator: this.$store.state.user.user.username,
        origin_x: 0,
        origin_y: 0,
        dataset_id: this.srcDataset.id,
      })
        .catch((error) => {
          // TODO: handle error
          $toast.open({
            queue: true,
            duration: 5000,
            message: `Error creating annotation set: ${error.message}`,
            type: "error",
            position: "top",
          });
        });
      if (!resp || resp.error || !resp.result) {
        // TODO: handle error
        $toast.open({
          queue: true,
          duration: 5000,
          message: `Error creating annotation set: ${resp.error.message}`,
          type: "error",
          position: "top",
        });
        return null;
      }
      return resp.result;
    },

    async refreshAnnotationSets() {
      let sets = null;
      const resp = await this.dataConnect.getAnnotationSets({
        dataset_id: this.srcDataset.id,
        get_num_annotations: true,
        get_num_images: true,
        get_labels: true,
      })
        .catch((error) => {
          $toast.open({
            queue: true,
            duration: 5000,
            message: `Error retrieving sets: ${error.message}`,
            type: "error",
            position: "top",
          });
        });
      if (!resp || resp.error || !resp.result) {
        $toast.open({
          queue: true,
          duration: 5000,
          message: `Error retrieving sets: ${resp.error.message}`,
          type: "error",
          position: "top",
        });
        sets = [];
      }
      sets = resp.result;
      const index = this.getDatasetIndex(this.srcDataset);
      this.$store.commit('datasets/setDatasetAnnotationSets', { index, sets });
    },

    getDatasetIndex(dataset) {
      return this.datasets.indexOf(this.datasets.find((d) => d.id === dataset.id));
    },
    getReviewTaskAnnotationSetName(annotationSets, srcName) {
      const annotationSetNames = annotationSets.map((set) => set.name);
      let tempSrcName;
      if (this.type === 'label') {
        tempSrcName = `${srcName}-LABELING`;
      } else if (this.type === 'audit') {
        tempSrcName = `${srcName}-AUDIT`;
      }
      if (!annotationSetNames.includes(tempSrcName)) {
        return tempSrcName;
      }

      let num = 1;
      while (annotationSetNames.includes(`${tempSrcName} (${num})`)) {
        num += 1;
      }
      return `${tempSrcName} (${num})`;
    },
  },
};

</script>

<style lang="scss" scoped>
.settings {
  padding: 0.75rem 3rem;
  overflow-y: scroll;
}

@media (min-width: $breakpoint-sm) {
  .settings {
    min-width: 480px;
  }
}

.footer {
  display: flex;
  flex-direction: row;
  padding: 0.75rem 3rem;
  justify-content: flex-end;
}

.dataset-selector{
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;

  select {
    width: 200px;
    margin-right: 20px;
  }

  button {
    width: 350px;
  }
}

.result {
  display: flex;
  width: 100%;
  height: 100%;
  border-radius: 5px;
  font-size: 1rem;
  font-weight:600;
  padding: 10px;
  align-items: center;
  justify-content: center;
}

.error {
  @include themify() {
    background: rgba(182, 94, 94, 0.5) ;
    color: themed('color-error')
  }
}

.permission-list {
  display: flex;
  flex-direction: column !important;
  width: 100%;

  &__title {
    margin: 5px 0 5px 0;
    font-size: 1rem;
    font-weight: 600;
    color: rgba(rgb(0, 0, 0), 0.7);
  }
}

.role-grid-single-row {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 1fr;
  grid-auto-rows: auto;
}

.subtitle {
  text-align: left;
  font-size: 0.85rem;
  color: rgba(grey, 1);
}

.label-text {
  display: flex;
  flex-direction: row;
  cursor: pointer;
  align-items: center;
  color: var(--color-black) !important;
  font-size: 0.9rem;
  font-weight: 600;
  margin-left: 2px;
  width: 200px;
}

:deep(.v-label) {
  opacity: 1 !important;
}

.combobox {
  width: 100%;
  border-radius: 8px;
}

.split-radio[type="radio"] {
  height: 18px;
  width: 18px;
  margin-left: 15px;
  @include themify() {
    accent-color: themed('color-primary');
  }
}
</style>
